module.exports = __webpack_public_path__ + "static/media/by.db911c2e.svg";